import BlockProfileForm from '@/core/components/ProfileActions/BlockProfileForm/BlockProfileForm';

export default BlockProfileForm;
